
export default {
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    leftColumnClassObject() {
      return {
        'md:w-1/2': this.blok.left_column_width === '1/2',
        'md:w-1/4': this.blok.left_column_width === '1/4',
        'md:w-1/3': this.blok.left_column_width === '1/3',
        'md:w-2/5': this.blok.left_column_width === '2/5',
        'md:w-2/3': this.blok.left_column_width === '2/3',
      }
    },
    rightColumnClassObject() {
      return {
        'md:w-1/2': this.blok.right_column_width === '1/2',
        'md:w-1/4': this.blok.right_column_width === '1/4',
        'md:w-1/3': this.blok.right_column_width === '1/3',
        'md:w-2/5': this.blok.right_column_width === '2/5',
        'md:w-2/3': this.blok.right_column_width === '2/3',
      }
    },
  },
}
